import { ProcessingOverlay } from '@components'

import { BorderRadius, Color, Divider, Modal, Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { useSendAsEmailForm } from '../../../../contexts/sendAsEmailFormContext'
import { Attachments } from './elements/Attachments'
import { CCEmailRecipients } from './elements/CCEmailRecipients'
import { EmailMessage } from './elements/EmailMessage'
import { EmailRecipients } from './elements/EmailRecipients'
import { EmailSubject } from './elements/EmailSubject'
import { SendCopyToMyself } from './elements/SendCopyToMyself'
import * as Styled from './styles'

export const SendAsEmailModalBody = (): ReactElement => {
  const { isLoading, isSubmitting } = useSendAsEmailForm()

  return (
    <Modal.Body>
      <Styled.ModalBodyWrapper>
        {(isLoading || isSubmitting) && (
          <ProcessingOverlay color={Color.White} borderRadius={BorderRadius.R16} withAnimation />
        )}
        <EmailRecipients />
        <Space size="s6" />
        <CCEmailRecipients />
        <Space size="s12" />
        <SendCopyToMyself />
        <Space />
        <Divider />
        <Space />
        <EmailSubject />
        <Space />
        <EmailMessage />
        <Attachments />
      </Styled.ModalBodyWrapper>
    </Modal.Body>
  )
}
